import React, { useState, useEffect } from "react";
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import RealdoleadTable from "../components/RealdoleadTable";
import Viewmore_table from "../components/Viewmore_table";
import DataTable from '../components/RealdoleadTable';
import { mockData, columns } from '../Mockdata';
import LeadChart from "../components/Charts/LeadChart";
import LeadCard from "../components/RealdoLeadCard";
import SearchFilter from "../components/SearchFilter";
import EditModal from "../components/EditModal";
const RealDolead = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen((prevState) => !prevState);
  };

  useEffect(() => {
    // Toggle the 'toggle-sidebar' class on the <body> element
    if (isSidebarOpen) {
      document.body.classList.add("toggle-sidebar");
    } else {
      document.body.classList.remove("toggle-sidebar");
    }

    // Cleanup function to remove the class when the component is unmounted or state changes
    return () => {
      document.body.classList.remove("toggle-sidebar");
    };
  }, [isSidebarOpen]);
  return (
    <div>
      <Navbar toggleSidebar={toggleSidebar} />
      <Sidebar isOpen={isSidebarOpen} />
      <main id='main' className='main'>
        <div className='pagetitle'>
          <h1>Real Do Leads</h1>
          <nav>
            <ol className='breadcrumb'>
              <li className='breadcrumb-item'>
                <a href='index.html'>Home</a>
              </li>
              <li className='breadcrumb-item'>Realdo-lead</li>
         
            </ol>
          </nav>
        </div>

        <section className='section'>
          <div className='row'>
            <div className='col-lg-12'>
              <div className='card'>
                <div className='card-body'>
                <LeadChart />
                </div>
              </div>
             <LeadCard />
             <SearchFilter />
              <div className='card'>
                <div className='card-body p-3'>
                  <div class="table-responsive">
                  <DataTable data={mockData} columns={columns} />
                  </div>
                </div>
              </div>
            </div>
            
          </div>
        </section>
      </main>
      <Footer />
      <Viewmore_table />
      <EditModal />
    </div>
  );
};

export default RealDolead;
